
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { TaskTemplateTagModel } from './Entities.GormCrm.TaskTemplateTag';
import { TaskflowTemplateModel } from './Entities.GormCrm.TaskflowTemplate';
import { TaskActionType } from 'enums/TaskActionType';
import { Model, ModelProperty } from 'models/Model';


export class TaskTemplateModel extends Model<TaskTemplateModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'taskTemplate.property.id', isHidden: true },
		{ name: 'title', type: 'string', languageString: 'taskTemplate.property.title' },
		{ name: 'created', type: 'Date', languageString: 'taskTemplate.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'taskTemplate.property.deleted', isHidden: true },
		{ name: 'defaultDeadline', type: 'number', languageString: 'taskTemplate.property.defaultDeadline' },
		{ name: 'taskflowTemplateId', type: 'guid', languageString: 'taskTemplate.property.taskflowTemplateId' },
		{ name: 'step', type: 'number', languageString: 'taskTemplate.property.step' },
		{ name: 'taskActions', type: 'TaskActionModel[]', languageString: 'taskTemplate.property.taskActions', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } },
		{ name: 'taskTemplateTags', type: 'TaskTemplateTagModel[]', languageString: 'taskTemplate.property.taskTemplateTags', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskTemplateTagModel }, properties: () => { return TaskTemplateTagModel.classProperties } },
		{ name: 'taskflowTemplate', type: 'TaskflowTemplateModel', languageString: 'taskTemplate.property.taskflowTemplate', isHidden: true, isObject: true, new: () => { return new TaskflowTemplateModel }, properties: () => { return TaskflowTemplateModel.classProperties } },
		{ name: 'type', type: 'TaskActionType', languageString: 'taskTemplate.property.type' }
	];
	[key: string]: any;
	
	public id?: string;
	public title: string;
	public created?: Date;
	public deleted?: Date;
	public defaultDeadline?: number;
	public taskflowTemplateId?: string;
	public step: number;
	public taskActions: TaskActionModel[];
	public taskTemplateTags: TaskTemplateTagModel[];
	public taskflowTemplate?: TaskflowTemplateModel;
	public type: TaskActionType;
    
	constructor(){
		super();
		this.id = undefined;
		this.title = '';
		this.created = undefined;
		this.deleted = undefined;
		this.defaultDeadline = undefined;
		this.taskflowTemplateId = undefined;
		this.step = 0;
		this.taskActions = [];
		this.taskTemplateTags = [];
		this.taskflowTemplate = undefined;
		this.type = 0;
		
	}
	getProperties(){
		return TaskTemplateModel.classProperties;
	}
}

